import { render, staticRenderFns } from "./loginFrom.vue?vue&type=template&id=9afd8174&scoped=true&"
import script from "./loginFrom.vue?vue&type=script&lang=js&"
export * from "./loginFrom.vue?vue&type=script&lang=js&"
import style0 from "./loginFrom.vue?vue&type=style&index=0&id=9afd8174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afd8174",
  null
  
)

export default component.exports